// eslint-disable-next-line no-unused-vars
import request from '@/service/http'
export function add (data) {
    return request({
      url: '/api/account/save',
      method: 'post',
      data,
    })
  }
  export function searchList (data) {
    return request({
      url: '/api/account/searchList',
      method: 'post',
      data,
    })
  }
  export function detail (data) {
    return request({
      url: '/api/account/detail',
      method: 'post',
      data,
    })
  }
  export function updata (data) {
    return request({
      url: '/api/account/update',
      method: 'post',
      data,
    })
  }
  export function doReset (data) {
    return request({
      url: '/api/account/reset',
      method: 'post',
      data,
    })
  }
  /**
 * 编辑版本初始化
 */
export function deleteed (data) {
  return request({
    url: '/api/account/delete',
    method: 'post',
    data,
  })
}
/**
 * 编辑版本详情
 */
export function versionDetail (data) {
  return request({
    url: '/api/account/detail',
    method: 'post',
    data,
  })
}